import { EventSourcePolyfill } from 'event-source-polyfill';
import { AuthTokenManager } from '@classes/AuthTokenManager';

export function getStreamAuthHeaders() {
  const token = AuthTokenManager.getAccessToken();
  if (!token) return {};
  return { Authorization: `Bearer ${token}` };
}

export function createAuthedEventSource(url, { headers, withCredentials = true, ...rest } = {}) {
  return new EventSourcePolyfill(url, {
    ...rest,
    headers: { ...getStreamAuthHeaders(), ...(headers || {}) },
    withCredentials,
  });
}
